import $ from 'jquery';

const showAllCategories = () => {
    const $showAllButton = $('button[data-filter-show-category=-1]');
    const $allFilterButtons = $('[data-filter-show-category]');
    const $allItems = $('[data-filter-category-ids]');

    $allItems.removeAttr('data-filter-hidden');
    $allFilterButtons.removeAttr('data-filter-button-active');

    if ($showAllButton.attr('data-filter-button-active')) {
        $showAllButton.removeAttr('data-filter-button-active');
    } else {
        $showAllButton.attr('data-filter-button-active', true);
    }
};

const toggleCategory = id => {
    const $allFilterButtons = $('[data-filter-show-category]');
    $allFilterButtons.removeAttr('data-filter-button-active');

    // toggle current category button
    let $catButton = $(`[data-filter-show-category=${id}]`);

    if ($catButton.attr('data-filter-button-active')) {
        $catButton.removeAttr('data-filter-button-active');
    } else {
        $catButton.attr('data-filter-button-active', true);
    }

    let dataLayer = (window.dataLayer = window.dataLayer || []);
    let txt = $catButton.first().text().replace(/\s+/g, ' ').trim();

    dataLayer.push({
        faqFilterId: txt,
        event: 'faqFilterClick'
    });

    const allActiveCatIds = $('[data-filter-button-active]')
        .toArray()
        .map(filterButton => $(filterButton).attr('data-filter-show-category'));

    if (allActiveCatIds.length === 0) {
        showAllCategories();
        return;
    }

    const $allItems = $('[data-filter-category-ids]');

    $allItems.attr('data-filter-hidden', true);
    $allItems
        .toArray()
        .filter(item => {
            const itemCatIds = item.getAttribute('data-filter-category-ids');

            // get intersection of this item's cat ids and all active cat ids
            const activeItemCatIds = allActiveCatIds.filter(
                activeId => itemCatIds.indexOf(activeId) !== -1
            );

            return activeItemCatIds.length;
        })
        .forEach(item => $(item).removeAttr('data-filter-hidden'));
};

const handleFilterChange = e => {
    const catId = e.target.value;
    if (catId === '-1') {
        showAllCategories();
    } else {
        toggleCategory(catId);
    }
};

function faqListingBlock() {
    $('.js-faq-filter').on('click || change', handleFilterChange);
}

export default faqListingBlock;
